import { useQuery } from "@apollo/client";

import { MeGetClientInfoDocument } from "./useMeGetClientInfoQuery.generated";

export default function useMeGetClientInfoQuery(clientSlug: string) {
    const { data, loading, error } = useQuery(MeGetClientInfoDocument, {
        variables: { clientSlug },
    });

    return {
        loading,
        error,
        data: data?.meGetClientInfo,
    };
}
